<template>
  <div>
    <ts-dialog
      :title="title"
      :visible.sync="dialogIsVisible"
      width="360px"
      center
      append-to-body
      :show-close="false"
      class="user-picker"
    >
      <div class="filter-bar">
        <ts-search-bar size="mini" :placeholder="placeholder" :value="query" @input="handleQueryChange">
        </ts-search-bar>
      </div>
      <div class="content">
        <div v-for="option in filteredOptions" :key="option.id" class="row">
          <div class="user-info" :class="[shouldBeDisabled(option) ? 'disabled' : '']">
            <p class="username">{{ option.name }} / {{ option.companyName }}</p>
            <p class="email">{{ option.email }}</p>
          </div>
          <div>
            <ts-button
              v-if="checked[option.id]"
              type="primary"
              size="mini"
              circle
              filled
              @click="handleOptionCheck(option, false)"
            >
              <ts-icon icon="check" size="xx-small" color="#6d7587" />
            </ts-button>
            <template v-else>
              <ts-button v-if="!shouldBeDisabled(option)" size="mini" circle @click="handleOptionCheck(option, true)">
                <ts-icon icon="plus" size="xx-small" color="#6d7587" />
              </ts-button>
            </template>
          </div>
        </div>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button size="small" @click="handleAddUserClick">{{button}}</ts-button>
        </div>
      </span>
    </ts-dialog>
    <slot v-bind:handler="handleAvatarListClick">
    <AvatarList :can-add="canAdd" :users="value" @click="handleAvatarListClick" />
    </slot>
  </div>
</template>

<style lang="scss" scoped>
.user-picker::v-deep {
  .el-dialog__body {
    padding: 0;
  }
}

.filter-bar {
  padding: 0 26px 12px 26px;
}

.content {
  max-height: 400px;
  overflow: scroll;
  padding: 0 15px;
}

.row {
  padding: 8px 13px;
  display: flex;
  align-items: center;

  &:hover {
    border-radius: 32px;
    box-shadow: 5px 5px 10px 0 rgba(166, 171, 189, 0.48);
    background-blend-mode: soft-light;
    background-image: linear-gradient(280deg, rgba(0, 0, 0, 0) 100%, #000000 0%, #ffffff 0%);
  }
}

.permissions-icon {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 13px;
  height: 13px;
  border: 1px solid #6d7587;
  border-radius: 13px;
  margin-right: 8px;
}

.user-info {
  flex-grow: 1;
}

.email {
  font-family: Roboto;
  font-size: 10px;
  font-weight: 300;
  font-style: italic;
  color: #6d7587;
}

.footer {
  padding-top: 12px;
}
</style>

<script>
import AvatarList from '@/components/AvatarList.vue';

export default {
  components: {
    AvatarList
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search a user'
    },
    button: {
      type: String,
      default: 'Update users'
    },
    title: {
      type: String,
      default: 'Add or remove people'
    },
    canAdd: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    toggle: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogIsVisible: false,
      query: '',
      checked: {}
    };
  },
  computed: {
    hasSelectedOptions() {
      return Object.keys(this.checked).length > 0
    },
    filteredOptions() {
      if (!this.query) {
        return this.options;
      }
      const query = this.query.toLowerCase();
      return this.options.filter(
        o =>
          o.name?.toLowerCase().includes(query) ||
          o.companyName?.toLowerCase().includes(query) ||
          o.email?.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    handleAvatarListClick() {
      this.dialogIsVisible = true;
      this.checked = {};
      this.value.forEach(v => (this.checked[v.id] = true));
    },
    handleOptionCheck(option, value) {
      this.checked = {
        ...(this.multiple ? this.checked : {}),
        [option.id]: value
      };
      this.checked = Object.keys(this.checked).filter(c => this.checked[c]).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {});
    },
    handleQueryChange(query) {
      this.query = query;
    },
    handleAddUserClick() {
      const selectedUsers = this.options.filter(o => this.checked[o.id]);
      this.$emit('input', selectedUsers);
      this.dialogIsVisible = false;
    },
    shouldBeDisabled(option) {
      return this.hasSelectedOptions && (!this.multiple && !this.toggle) && !this.checked[option.id]
    }
  }
};
</script>
